export const TopBarSelectors = {
    Role: (state) => state?.TopBar?.role,
    View: (state) => state?.TopBar?.view,
};
